import React, { useState, useEffect } from 'react';

// NOTE: In a real-world scenario, these would be imported via npm.
// For this environment, we'll load them via script tags.
const JSPDF_CDN = "https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js";
const HTML2CANVAS_CDN = "https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js";


const languageData = {
  en: {
    appTitle: "SSC GD 2025 Physical Test",
    welcomeMessage: "Congratulations for being shortlisted for SSC GD PST/PET! 🎉 Testbook is here to help you prepare for the Physical Standard Test (PST) and the Physical Efficiency Test (PET).",
    pstSectionTitle: "Physical Standard Test (PST)",
    pstIntro: "Physical Standards for the posts are as follows:",
    tableHeaderParameter: "Parameter",
    tableHeaderMale: "Male",
    tableHeaderFemale: "Female",
    height: "Height",
    heightMaleValue: "170 cms",
    heightFemaleValue: "157 cms",
    chest: "Chest",
    chestMaleValue: "Un-expanded: 80 cms; Minimum expansion: 5 cms",
    chestFemaleValue: "Not taken",
    weight: "Weight",
    weightValue: "Proportionate to height and age as per medical standards.",
    noteRelaxation: "Note: Few categories of candidates are allowed relaxation in height and chest measurements.",
    assessPSTFitness: "Assess my fitness for PST",
    pstFormIntro: "Share your details below to check if you meet the PST standards, and also for guidance on how to prepare to meet the standards.",
    sex: "Sex",
    category: "Category",
    selectCategory: "Select Category",
    heightCm: "Height (cm)",
    weightKg: "Weight (kg)",
    chestUnexpanded: "Chest Size Unexpanded (cm)",
    chestExpanded: "Chest Size Expanded after Deep Inhalation (cm)",
    rollNumber: "Roll Number (SSC GD 2025)",
    placeholderSex: "e.g., Male",
    placeholderHeight: "e.g., 175",
    placeholderWeight: "e.g., 65.5",
    placeholderChestNormal: "e.g., 85",
    placeholderChestDeepInhale: "e.g., 90",
    placeholderRollNumber: "e.g., 1234567890",
    femaleNotRequired: "Not required for female candidates",
    chestMeasurementInfo: "How to measure Expanded Chest Size:",
    chestMeasureStep1: "Stand straight with arms at your sides",
    chestMeasureStep2: "Place measuring tape around chest at nipple level",
    chestMeasureStep3: "Take a deep breath and expand your chest fully",
    chestMeasureStep4: "Hold your breath while measurement is taken",
    chestMeasureStep5: "Ensure tape is horizontal and snug but not tight",
    chestMeasureStep6: "Record the maximum expansion measurement",
    chestSizeError: "Expanded Chest Size cannot be smaller than the Unexpanded Chest Size",
    rollNumberError: "Roll Number must be exactly 10 digits.",
    checkPSTEligibility: "Check PST Eligibility",
    pstResultTitle: "Do I meet the criteria for PST?",
    statusIncomplete: "Incomplete",
    messageIncomplete: "Please fill in all required fields and ensure Roll Number is 10 digits.",
    statusNo: "No",
    messageNo: "You do not meet the basic eligibility requirements (height).",
    statusYes: "Yes",
    messageYes: "Congratulations! You meet all PST criteria as of today. However, it is important to maintain the physical standards till the PST date, and you can get a simple plan made to suit you.",
    statusTentative: "Tentative",
    messageTentative: "You meet basic eligibility but need to work on some aspects.",
    detailedAssessment: "Detailed Assessment:",
    makePersonalizedPlanPST: "Make me a personalized plan to clear PST",
    pstPlanCtaTitle: "Ready for the Next Step?",
    pstPlanCtaSubtitle: "You meet the criteria. Get a personalized plan to ensure you pass the PST!",
    pstPlanCtaButton: "Get My PST Plan",
    pstPlanCtaButtonHide: "Hide Plan",
    eligibilityIssue: "Eligibility Issue",
    eligibilityIssueMessage: "Unfortunately, height requirements cannot be changed through preparation. Please verify your eligibility criteria or check if you qualify for any category-based relaxations.",
    pstWorkoutPlanTitle: "Your 8-Week Progressive Workout Plan",
    pstWorkoutPlanIntro: "Perform strength workouts 3-4 times a week on alternate days.",
    pstWeekHeader: "Weeks {week}",
    pstWarmupTitle: "Mandatory Warm-up (5-10 mins before each session)",
    pstWarmupDesc: "Light jogging, arm circles (forward and backward), torso twists, and shoulder rotations to prepare your muscles.",
    pstExercisePushups: "Push-ups (Standard, Incline, Decline)",
    pstExerciseDips: "Parallel Bar Dips",
    pstExerciseGym: "Gym Exercises (Optional)",
    pstGymExercisesDesc: "If you can access a gym, include Bench Press, Dumbbell Press, and Chest Flyes under guidance. Perform 3 sets of 8-12 reps, 2-3 times a week.",
    pstAssistanceNoteTitle: "If you cannot perform an exercise",
    pstAssistanceNoteDesc: "Do not worry. Start with an easier version. For Push-ups, begin with wall push-ups or knee push-ups. For Dips, use a resistance band for assistance. The goal is to build strength to perform the full exercise.",
    pstChestExpansionTitle: "Yoga for Chest Expansion & Flexibility (Do daily)",
    pstYogaBhujangasana: "Bhujangasana (भुजंगासन - Cobra Pose): Lie on your stomach, place palms under your shoulders. Inhale and lift your chest off the floor, keeping your navel down. Hold for 15-20 seconds. Helps open the chest.",
    pstYogaSetuBandhasana: "Setu Bandhasana (सेतु बन्धासन - Bridge Pose): Lie on your back with knees bent. Lift your hips off the floor while keeping your shoulders and feet planted. Hold for 15-20 seconds to expand the rib cage.",
    pstYogaMatsyasana: "Matsyasana (मत्स्यासन - Fish Pose): Lie on your back, place hands under your hips. Pressing on your elbows, lift your chest up to create an arch in your back and gently rest the crown of your head on the floor. Hold for 15-20 seconds.",
    pstYogaPranayama: "Pranayama (प्राणायाम - Yogic Breathing): Sit comfortably. Inhale deeply through your nose, allowing your chest to expand fully. Hold for a moment, then exhale slowly. Practice for 5 minutes.",
    pstCardio: "Light Cardio",
    pstSwimming: "If you have access to a swimming pool and can swim, 20-30 minutes of breaststroke or freestyle 2-3 times a week is excellent. Otherwise, 20-30 mins of brisk walking/light jogging.",
    pstSafetyFirstTitle: "⚠️ Safety First!",
    pstSafetyFirstDesc: "If you feel any sharp or persistent pain during these exercises, stop immediately. Rest and if the pain continues, consult a doctor before resuming.",
    pstDietPlanTitle: "Nutrition and Diet Plan",
    pstDietPlanIntro: "A good diet is crucial for muscle growth and recovery. This plan focuses on affordable, homemade Indian food.",
    pstDietProteinTitle: "Focus on Protein (for muscle repair and growth)",
    pstDietProteinVeg: "Vegetarian: Increase intake of dals (lentils), chana (chickpeas), rajma, homemade paneer, and curd.",
    pstDietProteinNonVeg: "Non-Vegetarian: Include eggs (2-3 per day) and chicken breast (2-3 times a week) in your diet.",
    pstDietGeneralTipsTitle: "General Tips",
    pstDietGeneralTipsDesc1: "Eat small, frequent meals (4-5 times a day).",
    pstDietGeneralTipsDesc2: "Include a handful of peanuts or roasted chana as a snack.",
    pstDietGeneralTipsDesc3: "Drink plenty of water throughout the day (3-4 litres).",
    pstDietGeneralTipsDesc4: "A glass of warm milk with turmeric before bed can help with recovery.",
    pstMaintenancePlanTitle: "Chest Maintenance & Buffering Plan",
    pstMaintenancePlanIntro: "You meet the criteria, which is great! This plan helps you maintain your size and add a small buffer. The goal is consistency, not exhaustion.",
    pstMaintenancePlanIntroExpansionNeeded: "You meet the criteria for chest size but not for chest expansion. This plan helps you maintain your chest size and add a small buffer while improving the chest expansion.",
    pstMaintenanceWorkoutDesc: "Perform the following workout 3-4 times a week on alternate days:",
    pstMaintenancePushups: "3 sets of your current maximum reps. Try to add 1 rep every week.",
    pstMaintenanceDips: "3 sets of your current maximum reps. Try to add 1 rep every week.",
    pstUnachievableTitle: "Professional Consultation Recommended",
    pstUnachievableDesc: "Your current measurements are significantly below the requirement. Achieving the goal in 6-8 weeks is very challenging and could lead to injury if not done under expert supervision. We strongly recommend consulting a certified physical trainer and a physician to create a safe, long-term plan.",
    petSectionTitle: "Physical Efficiency Test (PET)",
    raceRequirements: "Race Requirements:",
    tableHeaderEvent: "Event",
    tableHeaderRemarks: "Remarks",
    race: "Race",
    raceMale1: "5 Kms in 24 minutes",
    raceFemale1: "1.6 Kms in 8½ minutes",
    raceRemarks1: "For candidates other than those belonging to the Ladakh Region",
    raceMale2: "1.6 Kms in 7 minutes",
    raceFemale2: "800 metres in 5 minutes",
    raceRemarks2: "For candidates of Ladakh Region",
    notePregnantFemale: "Note: Pregnant female candidates may refer to the notification.",
    createPersonalizedTrainingPlan: "Create a personalized training plan for me",
    trainingAssessmentForm: "Training Assessment Form",
    petQ1: "How many minutes can you jog non-stop today on a flat road at your own pace?",
    petQ2: "In the last 30 days, on how many separate days did you do aerobic activity such as fast walking, running, cycling, football, or kabaddi?\nEnter a number from 0 to 30. (Example: if you were active on 8 days, write 8.)",
    petQ3: "What is your injury status today?",
    petQ3_Opt1: "No injury",
    petQ3_Opt2: "Mild injury",
    petQ3_Opt3: "Severe injury",
    selectInjuryStatus: "Select injury status",
    placeholderMinutes: "0-120",
    placeholderDays: "0-30",
    generatePETTrainingPlan: "Generate My Personalized PET Training Plan",
    alertFillAllPETFields: "Please answer all three questions to generate a plan.",
    petTrainingPlanTitle: "Your 8-Week Personalized PET Training Plan",
    unlockCtaTitle: "Unlock Your Full 8-Week Plan!",
    unlockCtaSubtitle: "Submit your details to view the complete plan.",
    unlockCtaButton: "Unlock Plan & Download",
    unlockCtaButtonMobile: "Unlock Plan",
    downloadModalTitle: "Download Your Plan",
    nameLabel: "Name",
    emailLabel: "Email",
    phoneLabel: "Phone Number",
    namePlaceholder: "e.g., John Doe",
    emailPlaceholder: "e.g., john.doe@example.com",
    phonePlaceholder: "e.g., 9876543210",
    submitDownloadButton: "Submit & Download PDF",
    submitButton: "Submit",
    submittingButton: "Submitting...",
    downloadPdfButton: "Download Plan(s) as PDF",
    pdfDownloadOnDesktop: "PDF download is available on desktop only.",
    planPA: `**Current Fitness Assessment:**
• Current pace: 8.3 min/km
• Target: 5km in 24 minutes (4.8 min/km pace)
• Training commitment: 3 days/week
• BMI: 21.6 (Normal)

**Progressive Running Plan:**

**Week 1-2: Base Building**
• 2 days easy jogging: 0.6km at comfortable pace
• 1 day interval training: 200m sprints x 5 with 2 min rest
• Rest days: Active recovery (walk, stretch)

**Week 3-4: Speed Development**
• Increase distance by 20%: 0.7km runs
• Tempo runs: 1km at target pace, 2 min rest, repeat 3 times
• Hill training: Find a slope, 10 x 30-second uphill sprints

**Week 5-6: Peak Phase**
• Intervals: 400m repeats x 4 at faster than target pace
• Tempo: 1.5km at target pace
• Long run: 1.8km easy

**Week 7: Taper**
• Reduce volume by 30-40%
• 1 day of light intervals: 200m x 3
• 2 days very easy, short jogs

**Week 8: Race Week**
• Monday: 1km very easy jog
• Wednesday: Rest
• Friday: Test Day! 5km in 24 minutes
`,
    planPB: `Based on your current level of fitness and training, you are advised to follow the plan below to build endurance.
**8-Week Plan (4 running days each week)**

**Weeks 1 & 2**
▸ Monday 25 min easy jog.
▸ Wednesday 8 repetitions of 1 min fast, 1 min walk.
▸ Friday 25 min easy jog.
▸ Sunday 35 min easy jog.

**Weeks 3 & 4**
▸ Monday 25 min easy.
▸ Wednesday 5 repetitions of 2 min fast, 1½ min walk.
▸ Friday 25 min steady run.
▸ Sunday 40 min easy.

**Weeks 5 & 6**
▸ Monday 30 min easy.
▸ Wednesday 4 repetitions of 3 min fast, 2 min walk.
▸ Friday 20 min steady.
▸ Sunday 45 min easy.

*End of Week 6*: full 24-minute trial; goal ≥ 5 km.

**Week 7**
▸ Monday 25 min easy.
▸ Wednesday 3 repetitions of 4 min fast, 3 min walk.
▸ Friday 25 min easy.
▸ Sunday 35 min steady.

**Week 8 (Taper)**
▸ Tuesday 20 min easy.
▸ Thursday 6 strides of 30 s fast with full recovery, then 10 min steady.
▸ Saturday: **Race Day**.`,
    planPC: `Based on your current level of fitness and training, you are in the category of a **“Run-Walk Starter”** and you will need dedication and consistent improved to reach the fitness level required. Here's the training plan for you.
**8-Week Plan (4 main runs + 1 micro-day = 5 movement days)**

**Week 1**
• Three run-walk sessions: 6 cycles of 2 min jog, 2 min walk.
• One brisk walk 30 min.

**Week 2**
• Three run-walk sessions: 6 cycles of 3 min jog, 2 min walk.
• One brisk walk 35 min.

**Week 3**
• Three run-walk sessions: 5 cycles of 4 min jog, 2 min walk.
• One continuous easy jog 25 min.
• Micro-day: 20 min brisk walk with mobility drills.

**Week 4**
• Two continuous easy jogs 25 min each.
• One stride session: 8 × 20 s fast with full recovery.
• One jog-walk 45 min.
• Micro-day: 20 min walk with mobility.

**Week 5**
• Two easy jogs 30 min.
• One speed session: 5 × 1 min fast, 1 min walk.
• One easy jog 45 min.
• Micro-day: 6 × 30 s barefoot strides plus core work.

**Week 6**
• Two easy jogs 30 min.
• One speed session: 4 × 2 min fast, 1½ min walk.
• One easy jog 50 min.
• Micro-day: 6 barefoot strides.
• Sunday: **18-minute trial; aim ≥ 3.75 km**.

**Week 7**
• Two easy jogs.
• One steady run 45 min.
• Wednesday: **24-minute trial; aim ≥ 5 km**.
• Micro-day: 15 min recovery walk with stretching.

**Week 8 (Taper)**
• Two easy jogs 25 min.
• Saturday: **Race Day**.`,
    planPD: `Based on your current level of fitness and training, you look like a **“Beginner”** to running, and you will need to train with dedication and intensity to be able to reach the fitness level required. Below is the plan for you to start slowly and increase intensity gradually.
**8-Week Plan (3 main runs + 1 micro-day = 4 movement days)**

**Week 1**
• Two run-walk sessions: 1 min jog, 2 min walk repeated twice.
• One brisk walk 20–30 min.

**Week 2**
• Three run-walk sessions: 3 cycles of 2 min jog, 2 min walk.
• Micro-day: 15 min easy walk with mobility drills.

**Week 3**
• Three run-walk sessions: 4 cycles of 3 min jog, 2 min walk.
• Micro-day: 15 min mobility walk.

**Week 4**
• Three run-walk sessions: 4 cycles of 4 min jog, 2 min walk.
• Micro-day: 15 min mobility walk.

**Week 5**
• Two continuous jog-walk sessions 30 min each.
• One stride session: 6 × 15 s fast.
• Micro-day: 20 min mobility walk.

**Week 6**
• One session: 3 cycles of 5 min steady run, 2 min walk.
• Two easy jogs 30 min.
• Micro-day: 6 × 30 s fast strides on grass.
• Sunday: **18-minute trial if earlier 12-minute trial ≥ 1.8 km**.

**Week 7**
• Two easy jogs 35 min.
• One speed session: 4 × 1 min fast, 1 min walk.
• Micro-day: 20 min recovery walk.

**Week 8**
• Two easy jogs 25 min.
• Saturday: **24-minute trial; if you reach 5 km, schedule your official race within the next few days.**`,
    planPR: "Since you are carrying a mild injury, please qualified physician or physiotherapist before beginning any running programme.",
    planPS: `**Severe Injury – Training Suspended**

You reported severe pain. Please consult a qualified physician or physiotherapist before beginning any running programme.`,
    alertClose: "Close",
    male: "Male",
    female: "Female",
    heightPass: "✅ Height: {heightNum} cm (Minimum: {requiredHeight} cm) - PASS",
    heightFail: "❌ Height: {heightNum} cm (Minimum: {requiredHeight} cm) - FAIL",
    weightProportionatePass: "✅ Weight: Proportionate - PASS",
    weightProportionateFail: "❌ Weight: Not Proportionate - Let's get to work",
    chestMeetsCriteriaDetailed: "✅ Chest Size & Expansion: {userChest} cm & {userExpansion} cm (Minimum for your category: {reqChest} cm & {reqExpansion} cm) - Meets Criteria",
    chestDoesNotMeetDetailed: "❌ Chest Size & Expansion: {userChest} cm & {userExpansion} cm (Minimum for your category: {reqChest} cm & {reqExpansion} cm) - Does not meet criteria at this moment - Let's get to work",
    chestNotProvided: "Chest measurements not provided - Cannot verify chest criteria",
    chestNotRequiredFemale: "Chest measurement not required for female candidates",
    categories_general: 'General',
    categories_st: 'All candidates belonging to Scheduled Tribes',
    categories_st_ne: 'All Scheduled Tribe candidates of North Eastern States (NE States)',
    categories_st_lwe: 'All Scheduled Tribe candidates of Left-Wing Extremism affected districts',
    categories_garhwali_kumaoni_dogra_maratha_states: 'Garhwalis, Kumaonis, Dogras, Maratas and candidates from Assam, Himachal Pradesh, Jammu & Kashmir, Ladakh',
    categories_ne_states: 'Candidates from North-Eastern States (Arunachal Pradesh, Manipur, Meghalaya, Mizoram, Nagaland, Sikkim, Tripura)',
    categories_gta: 'Gorkha Territorial Administration (GTA)',
    km: "km",
    day: "day",
    days: "days",
    note: "Note",
    noteThisTool: "This tool provides guidance based on official PST criteria from SSC GD notification. Final eligibility is determined by official medical examination. Category-based relaxations are applied as per government guidelines.",
  },
  hi: {
    appTitle: "SSC GD 2025 Physical Test",
    welcomeMessage: "SSC GD PST/PET के लिए शॉर्टलिस्ट होने पर बधाई! 🎉 टेस्टबुक आपको Physical Standard Test (PST) और Physical Efficiency Test (PET) के लिए तैयार करने में मदद करने के लिए यहाँ है।",
    pstSectionTitle: "Physical Standard Test (PST)",
    pstIntro: "पदों के लिए शारीरिक मानक इस प्रकार हैं:",
    tableHeaderParameter: "पैरामीटर",
    tableHeaderMale: "पुरुष",
    tableHeaderFemale: "महिला",
    height: "ऊँचाई",
    heightMaleValue: "170 सेमी",
    heightFemaleValue: "157 सेमी",
    chest: "छाती",
    chestMaleValue: "बिना फुलाए: 80 सेमी; न्यूनतम विस्तार: 5 सेमी",
    chestFemaleValue: "महिला अभ्यर्थियों के सीने का माप नहीं लिया जाएगा।",
    weight: "भार",
    weightValue: "चिकित्सा मानकों के अनुसार ऊँचाई और आयु के आनुपातिक।",
    noteRelaxation: "नोट: कुछ श्रेणियों के उम्मीदवारों को ऊँचाई और छाती के माप में छूट की अनुमति है।",
    assessPSTFitness: "PST के लिए मेरी फिटनेस का मूल्यांकन करें",
    pstFormIntro: "PST मानकों को पूरा करने के लिए अपनी फिटनेस की जांच के लिए और तैयारी के लिए मार्गदर्शन प्राप्त करने के लिए नीचे अपना विवरण साझा करें।",
    sex: "लिंग",
    category: "श्रेणी",
    selectCategory: "श्रेणी चुनें",
    heightCm: "ऊँचाई (सेमी)",
    weightKg: "भार (किग्रा)",
    chestUnexpanded: "छाती का आकार बिना फुलाए (सेमी)",
    chestExpanded: "गहरी श्वास के बाद छाती का विस्तारित आकार (सेमी)",
    rollNumber: "Roll Number (SSC GD 2025)",
    placeholderSex: "जैसे, पुरुष",
    placeholderHeight: "जैसे, 175",
    placeholderWeight: "जैसे, 65.5",
    placeholderChestNormal: "जैसे, 85",
    placeholderChestDeepInhale: "जैसे, 90",
    placeholderRollNumber: "जैसे, 1234567890",
    femaleNotRequired: "महिला उम्मीदवारों के लिए आवश्यक नहीं है",
    chestMeasurementInfo: "विस्तारित छाती का आकार कैसे मापें:",
    chestMeasureStep1: "सीधे खड़े हों और अपनी भुजाएँ बगल में रखें",
    chestMeasureStep2: "मापने वाले टेप को छाती के चारों ओर निप्पल के स्तर पर रखें",
    chestMeasureStep3: "गहरी साँस लें और अपनी छाती को पूरी तरह से फैलाएँ",
    chestMeasureStep4: "माप लेते समय अपनी साँस रोककर रखें",
    chestMeasureStep5: "सुनिश्चित करें कि टेप क्षैतिज और आरामदायक हो लेकिन कसकर न हो",
    chestMeasureStep6: "अधिकतम विस्तार माप रिकॉर्ड करें",
    chestSizeError: "विस्तारित छाती का आकार अविस्तारित छाती के आकार से छोटा नहीं हो सकता",
    rollNumberError: "रोल नंबर ठीक 10 अंकों का होना चाहिए।",
    checkPSTEligibility: "PST पात्रता जांचें",
    pstResultTitle: "क्या मैं PST के मानदंडों को पूरा करता हूँ?",
    statusIncomplete: "अधूरा",
    messageIncomplete: "कृपया सभी आवश्यक फ़ील्ड भरें और सुनिश्चित करें कि रोल नंबर 10 अंक का हो।",
    statusNo: "नहीं",
    messageNo: "आप बुनियादी पात्रता आवश्यकताओं (ऊंचाई) को पूरा नहीं करते हैं।",
    statusYes: "हाँ",
    messageYes: "बधाई हो! आप आज की तारीख में सभी PST मानदंडों को पूरा करते हैं। हालांकि, PST की तारीख तक शारीरिक मानकों को बनाए रखना महत्वपूर्ण है, और आप अपने लिए एक सरल योजना बनवा सकते हैं।",
    statusTentative: "अस्थायी",
    messageTentative: "आप बुनियादी पात्रता को पूरा करते हैं लेकिन कुछ पहलुओं पर काम करने की आवश्यकता है।",
    detailedAssessment: "विस्तृत मूल्यांकन:",
    makePersonalizedPlanPST: "मुझे PST क्लियर करने के लिए एक व्यक्तिगत योजना बनाएँ",
    pstPlanCtaTitle: "अगले चरण के लिए तैयार हैं?",
    pstPlanCtaSubtitle: "आप मानदंडों को पूरा करते हैं। यह सुनिश्चित करने के लिए एक व्यक्तिगत योजना प्राप्त करें कि आप PST पास करें!",
    pstPlanCtaButton: "मेरी PST योजना प्राप्त करें",
    pstPlanCtaButtonHide: "योजना छिपाएँ",
    eligibilityIssue: "पात्रता संबंधी समस्या",
    eligibilityIssueMessage: "दुर्भाग्य से, ऊंचाई की आवश्यकताओं को तैयारी के माध्यम से बदला नहीं जा सकता है। कृपया अपनी पात्रता मानदंडों को सत्यापित करें या जांचें कि क्या आप किसी श्रेणी-आधारित छूट के लिए योग्य हैं।",
    pstWorkoutPlanTitle: "आपकी 8-सप्ताह की प्रगतिशील वर्कआउट योजना",
    pstWorkoutPlanIntro: "यह योजना धीरे-धीरे शक्ति और सहनशक्ति बढ़ाने के लिए बनाई गई है। स्ट्रेंथ वर्कआउट को सप्ताह में 3-4 बार एकांतर दिनों में करें।",
    pstWeekHeader: "सप्ताह {week}",
    pstWarmupTitle: "अनिवार्य वार्म-अप (प्रत्येक सत्र से 5-10 मिनट पहले)",
    pstWarmupDesc: "अपनी मांसपेशियों को तैयार करने के लिए हल्का जॉगिंग, आर्म सर्कल (आगे और पीछे), टॉर्सो ट्विस्ट और शोल्डर रोटेशन करें।",
    pstExercisePushups: "पुश-अप्स (साधारण, झुके हुए, ढलान वाले)",
    pstExerciseDips: "पैरेलल बार डिप्स",
    pstExerciseGym: "जिम में व्यायाम (एकांतर)",
    pstGymExercisesDesc: "यदि आप जिम जा सकते हैं, तो मार्गदर्शन में बेंच प्रेस, डंबल प्रेस, और चेस्ट फ्लाई शामिल करें। सप्ताह में 2-3 बार 8-12 रेप्स के 3 सेट करें।",
    pstAssistanceNoteTitle: "यदि आप कोई व्यायाम नहीं कर पाते हैं",
    pstAssistanceNoteDesc: "चिंता न करें। एक आसान संस्करण से शुरू करें। पुश-अप्स के लिए, दीवार पुश-अप या घुटने के पुश-अप से शुरू करें। डिप्स के लिए, सहायता के लिए एक रेजिस्टेंस बैंड का उपयोग करें। लक्ष्य पूर्ण व्यायाम करने के लिए स्ट्रेंथ विकसित करना है।",
    pstChestExpansionTitle: "छाती के विस्तार और लचीलेपन के लिए योग (रोजाना करें)",
    pstYogaBhujangasana: "भुजंगासन (कोबरा पोज): पेट के बल लेट जाएं, हथेलियों को कंधों के नीचे रखें। सांस लेते हुए अपनी छाती को फर्श से ऊपर उठाएं, नाभि को नीचे रखें। 15-20 सेकंड के लिए रुकें। यह छाती को खोलने में मदद करता है।",
    pstYogaSetuBandhasana: "सेतु बन्धासन (ब्रिज पोज): अपनी पीठ के बल लेट जाएं और घुटनों को मोड़ें। अपने कंधों और पैरों को जमीन पर रखते हुए अपने कूल्हों को फर्श से ऊपर उठाएं। पसली के ढांचे को फैलाने के लिए 15-20 सेकंड के लिए रुकें।",
    pstYogaMatsyasana: "मत्स्यासन (मछली पोज): अपनी पीठ के बल लेट जाएं, हाथों को अपने कूल्हों के नीचे रखें। अपनी कोहनी पर दबाव डालते हुए, अपनी छाती को ऊपर उठाएं ताकि आपकी पीठ में एक मेहराब बन जाए और धीरे से अपने सिर के ऊपरी हिस्से को फर्श पर टिका दें। 15-20 सेकंड के लिए रुकें।",
    pstYogaPranayama: "प्राणायाम (योगिक श्वास): आराम से बैठें। अपनी नाक से गहरी सांस लें, जिससे आपकी छाती पूरी तरह से फैल जाए। एक पल के लिए रुकें, फिर धीरे-धीरे सांस छोड़ें। 5 मिनट तक अभ्यास करें।",
    pstCardio: "हल्का कार्डियो",
    pstSwimming: "यदि आपके पास स्विमिंग पूल की सुविधा है और आप तैर सकते हैं, तो सप्ताह में 2-3 बार 20-30 मिनट ब्रेस्टस्ट्रोक या फ्रीस्टाइल उत्कृष्ट है। अन्यथा, 20-30 मिनट तेज चलना/हल्की जॉगिंग करें।",
    pstSafetyFirstTitle: "⚠️ पहले सुरक्षा!",
    pstSafetyFirstDesc: "यदि आपको इन अभ्यासों के दौरान कोई तेज या लगातार दर्द महसूस होता है, तो तुरंत रुक जाएं। आराम करें और यदि दर्द बना रहता है, तो फिर से शुरू करने से पहले डॉक्टर से सलाह लें।",
    pstDietPlanTitle: "पोषण और आहार योजना",
    pstDietPlanIntro: "मांसपेशियों की वृद्धि और रिकवरी के लिए एक अच्छा आहार महत्वपूर्ण है। यह योजना सस्ते, घर पर बने भारतीय भोजन पर केंद्रित है।",
    pstDietProteinTitle: "प्रोटीन पर ध्यान दें (मांसपेशियों की मरम्मत और वृद्धि के लिए)",
    pstDietProteinVeg: "शाकाहारी: दाल, चना, राजमा, घर का बना पनीर और दही का सेवन बढ़ाएँ।",
    pstDietProteinNonVeg: "मांसाहारी: अपने आहार में अंडे (प्रति दिन 2-3) और चिकन ब्रेस्ट (सप्ताह में 2-3 बार) शामिल करें।",
    pstDietGeneralTipsTitle: "सामान्य सुझाव",
    pstDietGeneralTipsDesc1: "छोटे, लगातार भोजन करें (दिन में 4-5 बार)।",
    pstDietGeneralTipsDesc2: "नाश्ते के रूप में मुट्ठी भर मूंगफली या भुने हुए चने शामिल करें।",
    pstDietGeneralTipsDesc3: "दिन भर में खूब पानी पिएं (3-4 लीटर)।",
    pstDietGeneralTipsDesc4: "सोने से पहले हल्दी वाला एक गिलास दूध रिकवरी में मदद कर सकता है।",
    pstMaintenancePlanTitle: "छाती रखरखाव और बफरिंग योजना",
    pstMaintenancePlanIntro: "आप मानदंडों को पूरा करते हैं, जो बहुत अच्छा है! यह योजना आपको अपना आकार बनाए रखने और एक छोटा बफर जोड़ने में मदद करती है। लक्ष्य निरंतरता है, थकावट नहीं।",
    pstMaintenancePlanIntroExpansionNeeded: "आप छाती के आकार का मानदंड तो पूरा करते हैं, लेकिन छाती के फुलाव का नहीं। यह योजना आपको अपने छाती के आकार को बनाए रखने और फुलाव में सुधार करते हुए एक छोटा बफर जोड़ने में मदद करती है।",
    pstMaintenanceWorkoutDesc: "निम्नलिखित वर्कआउट को सप्ताह में 3-4 बार एकांतर दिनों में करें:",
    pstMaintenancePushups: "आपके वर्तमान अधिकतम रेप्स के 3 सेट। हर हफ्ते 1 रेपिटिशन जोड़ने की कोशिश करें।",
    pstMaintenanceDips: "आपके वर्तमान अधिकतम रेप्स के 3 सेट। हर हफ्ते 1 रेपिटिशन जोड़ने की कोशिश करें।",
    pstUnachievableTitle: "पेशेवर परामर्श की सिफारिश की जाती है",
    pstUnachievableDesc: "आपके वर्तमान माप आवश्यकता से काफी नीचे हैं। 6-8 सप्ताह में लक्ष्य प्राप्त करना बहुत चुनौतीपूर्ण है और विशेषज्ञ पर्यवेक्षण के बिना करने पर चोट लग सकती है। हम एक सुरक्षित, दीर्घकालिक योजना बनाने के लिए एक प्रमाणित शारीरिक प्रशिक्षक और एक चिकित्सक से परामर्श करने की दृढ़ता से सलाह देते हैं।",
    petSectionTitle: "शारीरिक दक्षता परीक्षा (PET)",
    raceRequirements: "दौड़ की आवश्यकताएँ:",
    tableHeaderEvent: "आयोजन",
    tableHeaderRemarks: "टिप्पणियाँ",
    race: "दौड़",
    raceMale1: "24 मिनट में 5 Kms",
    raceFemale1: "8½ मिनट में 1.6 Kms",
    raceRemarks1: "लद्दाख क्षेत्र से संबंधित उम्मीदवारों के अलावा अन्य उम्मीदवारों के लिए",
    raceMale2: "7 मिनट में 1.6 Kms",
    raceFemale2: "5 मिनट में 800 metres",
    raceRemarks2: "लद्दाख क्षेत्र के उम्मीदवारों के लिए",
    notePregnantFemale: "नोट: गर्भवती महिला उम्मीदवार अधिसूचना का संदर्भ ले सकती हैं।",
    createPersonalizedTrainingPlan: "मेरे लिए एक व्यक्तिगत प्रशिक्षण योजना बनाएँ",
    trainingAssessmentForm: "प्रशिक्षण मूल्यांकन फॉर्म",
    petQ1: "आज आप समतल सड़क पर अपनी गति से बिना रुके कितने मिनट जॉगिंग कर सकते हैं?",
    petQ2: "पिछले 30 दिनों में, आपने कितने अलग-अलग दिनों में एरोबिक गतिविधि जैसे तेज चलना, दौड़ना, साइकिल चलाना, फुटबॉल, या कबड्डी की?\n0 से 30 तक एक संख्या दर्ज करें। (उदाहरण: यदि आप 8 दिन सक्रिय थे, तो 8 लिखें।)",
    petQ3: "आज आपकी चोट की स्थिति क्या है?",
    petQ3_Opt1: "कोई चोट नहीं",
    petQ3_Opt2: "हल्की चोट",
    petQ3_Opt3: "गंभीर चोट",
    selectInjuryStatus: "चोट की स्थिति चुनें",
    placeholderMinutes: "0-120",
    placeholderDays: "0-30",
    generatePETTrainingPlan: "मेरी व्यक्तिगत PET प्रशिक्षण योजना उत्पन्न करें",
    alertFillAllPETFields: "योजना बनाने के लिए कृपया सभी तीन प्रश्नों के उत्तर दें।",
    petTrainingPlanTitle: "आपकी 8-सप्ताह की व्यक्तिगत PET प्रशिक्षण योजना",
    unlockCtaTitle: "अपनी पूरी 8-सप्ताह की योजना अनलॉक करें!",
    unlockCtaSubtitle: "पूरी योजना देखने और अपनी पीडीएफ डाउनलोड करने के लिए अपना विवरण जमा करें।",
    unlockCtaButton: "पूरी योजना अनलॉक और डाउनलोड करें",
    unlockCtaButtonMobile: "योजना अनलॉक करें",
    downloadModalTitle: "अपनी योजना डाउनलोड करें",
    nameLabel: "नाम",
    emailLabel: "ईमेल",
    phoneLabel: "फोन नंबर",
    namePlaceholder: "जैसे, जॉन डो",
    emailPlaceholder: "जैसे, john.doe@example.com",
    phonePlaceholder: "जैसे, 9876543210",
    submitDownloadButton: "सबमिट और डाउनलोड करें",
    submitButton: "सबमिट करें",
    submittingButton: "सबमिट किया जा रहा है...",
    downloadPdfButton: "योजना(ओं) को पीडीएफ के रूप में डाउनलोड करें",
    pdfDownloadOnDesktop: "पीडीएफ डाउनलोड केवल डेस्कटॉप पर उपलब्ध है।",
    planPA: `**वर्तमान फिटनेस मूल्यांकन:**
• वर्तमान गति: 8.3 मिनट/किमी
• लक्ष्य: 24 मिनट में 5 किमी (4.8 मिनट/किमी गति)
• प्रशिक्षण प्रतिबद्धता: 3 दिन/सप्ताह
• BMI: 21.6 (सामान्य)

**प्रगतिशील रनिंग योजना:**

**सप्ताह 1-2: आधार निर्माण**
• 2 दिन आसान जॉगिंग: आरामदायक गति से 0.6 किमी
• 1 दिन अंतराल प्रशिक्षण: 200 मीटर स्प्रिंट x 5, 2 मिनट आराम के साथ
• आराम के दिन: सक्रिय रिकवरी (चलना, स्ट्रेच)

**सप्ताह 3-4: गति विकास**
• दूरी बढ़ाकर 1 किमी करें, 2 दिन/सप्ताह
• टेम्पो रन: लक्ष्य गति से 1 किमी, 2 मिनट आराम, 3 बार दोहराएं
• लंबी दौड़: 1.2 किमी आसान

**सप्ताह 5-6: पीक चरण**
• अंतराल: 400 मीटर दोहराव x 4 लक्ष्य गति से तेज
• टेम्पो: लक्ष्य गति से 1.5 किमी
• लंबी दौड़: 1.8 किमी आसान

**सप्ताह 7: टेपर**
• वॉल्यूम 30-40% कम करें
• 1 दिन हल्का अंतराल: 200 मीटर x 3
• 2 दिन बहुत आसान, छोटी जॉगिंग 

**सप्ताह 8: रेस सप्ताह**
• सोमवार: 1 किमी बहुत आसान जॉगिंग 
• बुधवार: आराम
• शुक्रवार: टेस्ट दिवस! 24 मिनट में 5 किमी
`,
    planPB: `आपकी वर्तमान फिटनेस और प्रशिक्षण के स्तर के आधार पर, आपको सहनशक्ति बनाने के लिए नीचे दी गई योजना का पालन करने की सलाह दी जाती है।
**8-सप्ताह की योजना (प्रत्येक सप्ताह 4 दौड़ने वाले दिन)**

**सप्ताह 1 और 2**
▸ सोमवार 25 मिनट आसान जॉगिंग ।
▸ बुधवार 1 मिनट तेज, 1 मिनट चलने के 8 दोहराव।
▸ शुक्रवार 25 मिनट आसान जॉगिंग ।
▸ रविवार 35 मिनट आसान जॉगिंग ।

**सप्ताह 3 और 4**
▸ सोमवार 25 मिनट आसान।
▸ बुधवार 2 मिनट तेज, 1½ मिनट चलने के 5 दोहराव।
▸ शुक्रवार 25 मिनट स्थिर दौड़।
▸ रविवार 40 मिनट आसान।

**सप्ताह 5 और 6**
▸ सोमवार 30 मिनट आसान।
▸ बुधवार 3 मिनट तेज, 2 मिनट चलने के 4 दोहराव।
▸ शुक्रवार 20 मिनट स्थिर।
▸ रविवार 45 मिनट आसान।

*सप्ताह 6 का अंत*: पूरा 24 मिनट का ट्रायल; लक्ष्य ≥ 5 किमी।

**सप्ताह 7**
▸ सोमवार 25 मिनट आसान।
▸ बुधवार 4 मिनट तेज, 3 मिनट चलने के 3 दोहराव।
▸ शुक्रवार 25 मिनट आसान।
▸ रविवार 35 मिनट स्थिर।

**सप्ताह 8 (टेपर)**
▸ मंगलवार 20 मिनट आसान।
▸ गुरुवार 30 सेकंड तेज की 6 स्ट्राइड्स पूरी रिकवरी के साथ, फिर 10 मिनट स्थिर।
▸ शनिवार: **रेस का दिन**।`,
    planPC: `आपकी वर्तमान फिटनेस और प्रशिक्षण के स्तर के आधार पर, आप एक **“रन-वॉक स्टार्टर”** की श्रेणी में हैं और आपको आवश्यक फिटनेस स्तर तक पहुंचने के लिए समर्पण और निरंतर सुधार की आवश्यकता होगी। यहाँ आपके लिए प्रशिक्षण योजना है।
**8-सप्ताह की योजना (4 मुख्य दौड़ + 1 माइक्रो-डे = 5 गतिविधि दिन)**

**सप्ताह 1**
• तीन दौड़- वाकिंग सेशन: 2 मिनट जॉगिंग, 2 मिनट चलने के 6 चक्कर।
• एक 30 मिनट की तेज चाल।

**सप्ताह 2**
• तीन दौड़-वाकिंग सेशन: 3 मिनट जॉगिंग, 2 मिनट चलने के 6 चक्कर।
• एक 35 मिनट की तेज चाल।

**सप्ताह 3**
• तीन दौड़-वाकिंग सेशन: 4 मिनट जॉगिंग, 2 मिनट चलने के 5 चक्कर।
• एक निरंतर आसान जॉगिंग 25 मिनट।
• माइक्रो-डे: 20 मिनट तेज चाल और गतिशीलता अभ्यास।

**सप्ताह 4**
• दो निरंतर आसान जॉगिंग प्रत्येक 25 मिनट।
• एक स्ट्राइड सत्र: 8 × 20 सेकंड तेज पूरी रिकवरी के साथ।
• एक जॉग-वॉक 45 मिनट।
• माइक्रो-डे: 20 मिनट चलना और गतिशीलता।

**सप्ताह 5**
• दो आसान जॉगिंग 30 मिनट।
• एक स्पीड सत्र: 5 × 1 मिनट तेज, 1 मिनट चलना।
• एक आसान जॉगिंग 45 मिनट।
• माइक्रो-डे: 6 × 30 सेकंड नंगे पैर स्ट्राइड्स और कोर वर्क।

**सप्ताह 6**
• दो आसान जॉगिंग 30 मिनट।
• एक स्पीड सत्र: 4 × 2 मिनट तेज, 1½ मिनट चलना।
• एक आसान जॉगिंग 50 मिनट।
• माइक्रो-डे: 6 नंगे पैर স্ট্রाइड्स।
• रविवार: **18 मिनट का ट्रायल; लक्ष्य ≥ 3.75 किमी**।

**सप्ताह 7**
• दो आसान जॉगिंग ।
• एक स्थिर दौड़ 45 मिनट।
• बुधवार: **24 मिनट का ट्रायल; लक्ष्य ≥ 5 किमी**।
• माइक्रो-डे: 15 मिनट रिकवरी वॉक और स्ट्रेचिंग।

**सप्ताह 8 (टेपर)**
• दो आसान जॉगिंग 25 मिनट।
• शनिवार: **रेस का दिन**।`,
    planPD: `आपकी वर्तमान फिटनेस और प्रशिक्षण के स्तर के आधार पर, आप दौड़ने के लिए एक **“शुरुआती”** की तरह दिखते हैं, और आपको आवश्यक फिटनेस स्तर तक पहुंचने में सक्षम होने के लिए समर्पण और तीव्रता के साथ प्रशिक्षण की आवश्यकता होगी। नीचे आपके लिए धीरे-धीरे शुरू करने और धीरे-धीरे तीव्रता बढ़ाने की योजना है।
**8-सप्ताह की योजना (3 मुख्य दौड़ + 1 माइक्रो-डे = 4 गतिविधि दिन)**

**सप्ताह 1**
• दो दौड़-वाकिंग सेशन: 1 मिनट जॉगिंग , 2 मिनट चलना दो बार दोहराया गया।
• एक 20-30 मिनट की तेज चाल।

**सप्ताह 2**
• तीन दौड़-वाकिंग सेशन: 2 मिनट जॉगिंग , 2 मिनट चलने के 3 चक्र।
• माइक्रो-डे: 15 मिनट आसान चलना और गतिशीलता अभ्यास।

**सप्ताह 3**
• तीन दौड़-वाकिंग सेशन: 3 मिनट जॉगिंग , 2 मिनट चलने के 4 चक्र।
• माइक्रो-डे: 15 मिनट गतिशीलता चलना।

**सप्ताह 4**
• तीन दौड़-वाकिंग सेशन: 4 मिनट जॉगिंग , 2 मिनट चलने के 4 चक्र।
• माइक्रो-डे: 15 मिनट गतिशीलता चलना।

**सप्ताह 5**
• दो निरंतर जॉगिंग -वॉक सत्र प्रत्येक 30 मिनट।
• एक स्ट्राइड सत्र: 6 × 15 सेकंड तेज।
• माइक्रो-डे: 20 मिनट गतिशीलता चलना।

**सप्ताह 6**
• एक सत्र: 5 मिनट स्थिर दौड़, 2 मिनट चलने के 3 चक्र।
• दो आसान जॉगिंग 30 मिनट।
• माइक्रो-डे: घास पर 6 × 30 सेकंड तेज स्ट्राइड्स।
• रविवार: **18 मिनट का ट्रायल यदि पहले 12-मिनट का ट्रायल ≥ 1.8 किमी**।

**सप्ताह 7**
• दो आसान जॉगिंग 35 मिनट।
• एक स्पीड सत्र: 4 × 1 मिनट तेज, 1 मिनट चलना।
• माइक्रो-डे: 20 मिनट रिकवरी वॉक।

**सप्ताह 8**
• दो आसान जॉगिंग 25 मिनट।
• शनिवार: **24 मिनट का ट्रायल; यदि आप 5 किमी तक पहुँचते हैं, तो अगले कुछ दिनों के भीतर अपनी आधिकारिक दौड़ निर्धारित करें।**`,
    planPR: "चूंकि आपको हल्की चोट है, कृपया कोई भी दौड़ कार्यक्रम शुरू करने से पहले योग्य चिकित्सक या फिजियोथेरेपिस्ट से सलाह लें।",
    planPS: `**गंभीर चोट - प्रशिक्षण निलंबित**

आपने चलने में गंभीर दर्द की सूचना दी है। कृपया किसी भी दौड़ कार्यक्रम को शुरू करने से पहले एक योग्य चिकित्सक या फिजियोथेरेपिस्ट से परामर्श करें।`,
    alertClose: "बंद करें",
    male: "पुरुष",
    female: "महिला",
    heightPass: "✅ ऊँचाई: {heightNum} सेमी (न्यूनतम: {requiredHeight} सेमी) - उत्तीर्ण",
    heightFail: "❌ ऊँचाई: {heightNum} सेमी (न्यूनतम: {requiredHeight} सेमी) - अनुत्तीर्ण",
    weightProportionatePass: "✅ भार: आनुपातिक - उत्तीर्ण",
    weightProportionateFail: "❌ भार: आनुपातिक नहीं - काम करने की आवश्यकता है",
    chestMeetsCriteriaDetailed: "✅ छाती का आकार और विस्तार: {userChest} सेमी और {userExpansion} सेमी (आपकी श्रेणी के लिए न्यूनतम: {reqChest} सेमी और {reqExpansion} सेमी) - मानदंड पूरा हुआ",
    chestDoesNotMeetDetailed: "❌ छाती का आकार और विस्तार: {userChest} सेमी और {userExpansion} सेमी (आपकी श्रेणी के लिए न्यूनतम: {reqChest} सेमी और {reqExpansion} सेमी) - इस समय मानदंड पूरा नहीं हुआ - काम करने की आवश्यकता है",
    chestNotProvided: "⚠️ छाती का माप प्रदान नहीं किया गया - छाती के मानदंडों की पुष्टि नहीं की जा सकती",
    chestNotRequiredFemale: "ℹ️ महिला उम्मीदवारों के लिए छाती का माप आवश्यक नहीं है",
    categories_general: 'सामान्य',
    categories_st: 'अनुसूचित जनजातियों से संबंधित सभी उम्मीदवार',
    categories_st_ne: 'पूर्वोत्तर राज्यों (NE राज्यों) के सभी अनुसूचित जनजाति उम्मीदवार',
    categories_st_lwe: 'वामपंथी उग्रवाद प्रभावित जिलों के सभी अनुसूचित जनजाति उम्मीदवार',
    categories_garhwali_kumaoni_dogra_maratha_states: 'गढ़वाली, कुमाऊँनी, डोगरा, मराठा और असम, हिमाचल प्रदेश, जम्मू और कश्मीर, लद्दाख के उम्मीदवार',
    categories_ne_states: 'पूर्वोत्तर राज्यों (अरुणाचल प्रदेश, मणिपुर, मेघालय, मिजोरम, नागालैंड, सिक्किम, त्रिपुरा) के उम्मीदवार',
    categories_gta: 'गोरखा क्षेत्रीय प्रशासन (GTA) के उम्मीदवार',
    km: "किमी",
    day: "दिन",
    days: "दिन",
    note: "नोट",
    noteThisTool: "यह उपकरण SSC GD अधिसूचना से आधिकारिक PST मानदंडों के आधार पर मार्गदर्शन प्रदान करता है। अंतिम पात्रता आधिकारिक चिकित्सा परीक्षा द्वारा निर्धारित की जाती है। श्रेणी-आधारित छूट सरकारी दिशानिर्देशों के अनुसार लागू होती है।",
  }
};

// Custom hook to check if the view is mobile
const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < breakpoint);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
};


// Moved component definitions outside of PSTChecker to prevent re-renders and focus loss
const PetQuestion = ({ id, text, children }) => (
    <div>
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2 whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: text.replace(/\n/g, '<br />') }} />
        {children}
    </div>
);

const PetPlanRenderer = ({ content, isLocked, t, onUnlock, onDownload, isMobile }) => {
    if (!content) return null;

    const formatText = (text) => {
        return text
            .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
            .replace(/\*(.*?)\*/g, '<em>$1</em>');
    };

    if (isLocked) {
        const lines = content.split('\n');
        const visibleLineCount = Math.floor(lines.length * 0.2); // Show 20% of the plan
        const visibleContent = lines.slice(0, visibleLineCount).join('\n');
        const lockedContent = lines.slice(visibleLineCount).join('\n');

        return (
            <div>
                <div
                    className="whitespace-pre-wrap font-sans text-gray-700 text-sm leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: formatText(visibleContent) }}
                />

                <div className="relative mt-2">
                    <div className="blur-md pointer-events-none">
                        <div
                            className="whitespace-pre-wrap font-sans text-gray-700 text-sm leading-relaxed"
                            dangerouslySetInnerHTML={{ __html: formatText(lockedContent) }}
                        />
                    </div>
                    <div className="absolute inset-0 flex items-center justify-center p-4">
                        <div className="bg-slate-800 bg-opacity-90 rounded-lg p-4 sm:p-6 text-center max-w-md w-full mx-4">
                            <h3 className="text-xl sm:text-2xl font-bold text-white text-center">{t.unlockCtaTitle}</h3>
                            <p className="text-white text-center mt-2 mb-4 text-sm sm:text-base">{t.unlockCtaSubtitle}</p>
                            <button
                                onClick={onUnlock}
                                className="bg-blue-600 text-white font-bold py-2 px-5 sm:py-3 sm:px-6 rounded-lg hover:bg-blue-700 transition-transform duration-200 hover:scale-105"
                            >
                                {isMobile ? t.unlockCtaButtonMobile : t.unlockCtaButton}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div id="pet-plan-content">
            <div
                className="whitespace-pre-wrap font-sans text-gray-700 text-sm leading-relaxed"
                dangerouslySetInnerHTML={{ __html: formatText(content) }}
            />
            <div className="text-center mt-6">
                 {isMobile ? (
                    <p className="text-sm text-gray-600 italic p-2 bg-gray-100 rounded-md">
                        {t.pdfDownloadOnDesktop}
                    </p>
                 ) : (
                    <button
                        onClick={onDownload}
                        className="bg-green-600 text-white font-bold py-2 px-5 sm:py-3 sm:px-6 rounded-lg hover:bg-green-700 transition-transform duration-200 hover:scale-105 download-pdf-button"
                    >
                        {t.downloadPdfButton}
                    </button>
                 )}
            </div>
        </div>
    );
};

const DownloadModal = ({ t, onSubmit, onClose, formData, onChange, isSubmitting, isMobile }) => (
    <div className="fixed inset-0 bg-gray-800 bg-opacity-75 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-lg shadow-2xl p-6 sm:p-8 max-w-md w-full relative">
            <button
                onClick={onClose}
                className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl"
            >
                &times;
            </button>
            <h2 className="text-xl sm:text-2xl font-bold mb-6 text-center text-gray-800">{isMobile ? t.unlockCtaButtonMobile : t.downloadModalTitle}</h2>
            <form onSubmit={onSubmit} className="space-y-4">
                <div>
                    <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">{t.nameLabel} *</label>
                    <input
                        type="text"
                        name="name"
                        id="name"
                        required
                        placeholder={t.namePlaceholder}
                        value={formData.name}
                        onChange={onChange}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                </div>
                <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">{t.emailLabel} *</label>
                    <input
                        type="email"
                        name="email"
                        id="email"
                        required
                        placeholder={t.emailPlaceholder}
                        value={formData.email}
                        onChange={onChange}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                </div>
                <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">{t.phoneLabel} *</label>
                    <input
                        type="tel"
                        name="phone"
                        id="phone"
                        required
                        placeholder={t.phonePlaceholder}
                        value={formData.phone}
                        onChange={onChange}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                </div>
                <button
                    type="submit"
                    className="w-full bg-blue-600 text-white font-bold py-3 px-4 rounded-lg hover:bg-blue-700 transition-all duration-300 mt-4 disabled:bg-gray-400"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? t.submittingButton : (isMobile ? t.submitButton : t.submitDownloadButton)}
                </button>
            </form>
        </div>
    </div>
);

const PSTChecker = () => {
  const [formData, setFormData] = useState({
    sex: '',
    category: '',
    height: '',
    weight: '',
    chestNormal: '',
    chestDeepInhale: '',
    rollNumber: ''
  });

  const [language, setLanguage] = useState('hi'); // 'en' for English, 'hi' for Hindi
  const t = languageData[language]; // 't' for translations
  const isMobile = useIsMobile(); // Custom hook to check screen size
  
  const [categories, setCategories] = useState(() => {
    const initialT = languageData['hi'];
    return [
      { value: 'general', label: initialT.categories_general },
      { value: 'st', label: initialT.categories_st },
      { value: 'st_ne', label: initialT.categories_st_ne },
      { value: 'st_lwe', label: initialT.categories_st_lwe },
      { value: 'garhwali_kumaoni_dogra_maratha_states', label: initialT.categories_garhwali_kumaoni_dogra_maratha_states },
      { value: 'ne_states', label: initialT.categories_ne_states },
      { value: 'gta', label: t.categories_gta }
    ];
  });

  const [result, setResult] = useState(null);
  const [showPlan, setShowPlan] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [showPETForm, setShowPETForm] = useState(false);
  const [showChestInfo, setShowChestInfo] = useState(false);
  const [pstPlan, setPstPlan] = useState(null);
  
  const [petFormData, setPetFormData] = useState({ q1: '', q2_raw: '', q3: '' });
  const [petPlanContent, setPetPlanContent] = useState(null);
  const [isPlanUnlocked, setIsPlanUnlocked] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadFormData, setDownloadFormData] = useState({ name: '', email: '', phone: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [scriptsLoaded, setScriptsLoaded] = useState(false);

  // Effect to load external scripts for PDF generation
  useEffect(() => {
    const loadScript = (src) => {
        return new Promise((resolve, reject) => {
            if (document.querySelector(`script[src="${src}"]`)) {
                resolve();
                return;
            }
            const script = document.createElement('script');
            script.src = src;
            script.onload = () => resolve();
            script.onerror = () => reject(new Error(`Script load error for ${src}`));
            document.head.appendChild(script);
        });
    };

    Promise.all([
        loadScript(JSPDF_CDN), 
        loadScript(HTML2CANVAS_CDN)
    ])
      .then(() => setScriptsLoaded(true))
      .catch(error => console.error("Failed to load PDF scripts:", error));
  }, []);
  
  useEffect(() => {
    setCategories([
      { value: 'general', label: t.categories_general },
      { value: 'st', label: t.categories_st },
      { value: 'st_ne', label: t.categories_st_ne },
      { value: 'st_lwe', label: t.categories_st_lwe },
      { value: 'garhwali_kumaoni_dogra_maratha_states', label: t.categories_garhwali_kumaoni_dogra_maratha_states },
      { value: 'ne_states', label: t.categories_ne_states },
      { value: 'gta', label: t.categories_gta }
    ]);
  }, [language, t]);

  const getHeightRequirement = (sex, category) => {
    const requirements = {
      general: { male: 170, female: 157 },
      st: { male: 162.5, female: 150.0 },
      st_ne: { male: 157.0, female: 147.5 },
      st_lwe: { male: 160.0, female: 147.5 },
      garhwali_kumaoni_dogra_maratha_states: { male: 165.0, female: 155.0 },
      ne_states: { male: 162.5, female: 152.5 },
      gta: { male: 157.0, female: 152.5 }
    };
    return requirements[category]?.[sex.toLowerCase()] || requirements.general[sex.toLowerCase()];
  };

  const getChestRequirement = (category) => {
    const requirements = {
      general: { unExpanded: 80, expansion: 5 },
      st: { unExpanded: 76, expansion: 5 },
      st_ne: { unExpanded: 76, expansion: 5 },
      st_lwe: { unExpanded: 76, expansion: 5 },
      garhwali_kumaoni_dogra_maratha_states: { unExpanded: 78, expansion: 5 },
      ne_states: { unExpanded: 77, expansion: 5 },
      gta: { unExpanded: 77, expansion: 5 }
    };
    return requirements[category] || requirements.general;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'rollNumber') {
      const numericValue = value.replace(/[^0-9]/g, '');
      if (numericValue.length <= 10) {
        setFormData(prev => ({ ...prev, [name]: numericValue }));
      }
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };
  
  const handlePetInputChange = (e) => {
      const { name, value } = e.target;
      setPetFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleDownloadFormChange = (e) => {
    const { name, value } = e.target;
    setDownloadFormData(prev => ({ ...prev, [name]: value }));
  }

  const calculateBMI = (weight, height) => {
    if (!weight || !height) return 0;
    const heightInMeters = height / 100;
    return weight / (heightInMeters * heightInMeters);
  };

  const isWeightProportionate = (weight, height) => {
    const bmi = calculateBMI(weight, height);
    return bmi >= 18.5 && bmi <= 24.9;
  };
    
  const showCustomAlert = (message) => {
    const alertBox = document.createElement('div');
    alertBox.className = "fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4";
    alertBox.innerHTML = `<div class="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full text-center"><p class="text-lg font-semibold mb-4">${message}</p><button id="close-alert" class="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700">${t.alertClose}</button></div>`;
    document.body.appendChild(alertBox);
    document.getElementById('close-alert').onclick = () => document.body.removeChild(alertBox);
  };
  
  const checkCriteria = () => {
    const { sex, category, height, weight, chestNormal, chestDeepInhale, rollNumber } = formData;
    
    if (!sex || !category || !height || !weight || !rollNumber || rollNumber.length !== 10) {
      setResult({ status: t.statusIncomplete, message: t.messageIncomplete, details: [], needsWork: [] });
      return;
    }

    const heightNum = parseFloat(height);
    const weightNum = parseFloat(weight);
    const chestNormalNum = parseFloat(chestNormal);
    const chestDeepInhaleNum = parseFloat(chestDeepInhale);

    let details = [];
    let needsWork = [];
    let heightFail = false;

    const requiredHeight = getHeightRequirement(sex, category);
    if (heightNum >= requiredHeight) {
      details.push(t.heightPass.replace('{heightNum}', heightNum).replace('{requiredHeight}', requiredHeight));
    } else {
      details.push(t.heightFail.replace('{heightNum}', heightNum).replace('{requiredHeight}', requiredHeight));
      heightFail = true;
    }

    const weightProportionate = isWeightProportionate(weightNum, heightNum);
    if (weightProportionate) {
      details.push(t.weightProportionatePass);
    } else {
      details.push(t.weightProportionateFail);
      needsWork.push('weight');
    }

    if (sex === 'Male') {
      if (chestNormal && chestDeepInhale) {
        const chestReq = getChestRequirement(category);
        const expansion = chestDeepInhaleNum - chestNormalNum;
        if (chestNormalNum >= chestReq.unExpanded && expansion >= chestReq.expansion) {
          details.push(t.chestMeetsCriteriaDetailed.replace('{userChest}', chestNormalNum).replace('{userExpansion}', expansion.toFixed(1)).replace('{reqChest}', chestReq.unExpanded).replace('{reqExpansion}', chestReq.expansion));
        } else {
          details.push(t.chestDoesNotMeetDetailed.replace('{userChest}', chestNormalNum).replace('{userExpansion}', expansion.toFixed(1)).replace('{reqChest}', chestReq.unExpanded).replace('{reqExpansion}', chestReq.expansion));
          needsWork.push('chest');
        }
      } else {
        details.push(t.chestNotProvided);
        needsWork.push('chest');
      }
    } else {
      details.push(t.chestNotRequiredFemale);
    }

    let status, message;
    if (heightFail) {
      status = t.statusNo;
      message = t.messageNo;
    } else if (needsWork.length === 0) {
      status = t.statusYes;
      message = t.messageYes;
    } else {
      status = t.statusTentative;
      message = t.messageTentative;
    }

    setResult({ status, message, details, needsWork, heightFail });
    setShowPlan(false);
  };

  const generatePSTChestPlan = () => {
    const { chestNormal, chestDeepInhale, category } = formData;
    const chestReq = getChestRequirement(category);
    const chestNormalNum = parseFloat(chestNormal) || 0;
    const chestDeepInhaleNum = parseFloat(chestDeepInhale) || 0;
    
    const userExpansion = chestDeepInhaleNum - chestNormalNum;
    const deficit = chestReq.unExpanded - chestNormalNum;

    const commonElements = {
        warmup: { title: t.pstWarmupTitle, desc: t.pstWarmupDesc },
        safety: { title: t.pstSafetyFirstTitle, desc: t.pstSafetyFirstDesc },
        expansion: { title: t.pstChestExpansionTitle, items: [t.pstYogaBhujangasana, t.pstYogaSetuBandhasana, t.pstYogaMatsyasana, t.pstYogaPranayama] },
        cardio: { title: t.pstCardio, desc: t.pstSwimming },
        assistance: { title: t.pstAssistanceNoteTitle, desc: t.pstAssistanceNoteDesc }
    };

    const dietPlan = {
        title: t.pstDietPlanTitle,
        intro: t.pstDietPlanIntro,
        protein: { title: t.pstDietProteinTitle, veg: t.pstDietProteinVeg, nonVeg: t.pstDietProteinNonVeg },
        tips: { title: t.pstDietGeneralTipsTitle, items: [t.pstDietGeneralTipsDesc1, t.pstDietGeneralTipsDesc2, t.pstDietGeneralTipsDesc3, t.pstDietGeneralTipsDesc4] }
    };

    if (deficit <= 0) {
        const expansionMet = userExpansion >= chestReq.expansion;
        return { 
            type: 'maintenance', 
            title: t.pstMaintenancePlanTitle, 
            intro: expansionMet ? t.pstMaintenancePlanIntro : t.pstMaintenancePlanIntroExpansionNeeded, 
            workoutDesc: t.pstMaintenanceWorkoutDesc, 
            workouts: [{ exercise: t.pstExercisePushups, reps: t.pstMaintenancePushups }, { exercise: t.pstExerciseDips, reps: t.pstMaintenanceDips }], 
            ...commonElements, 
            dietPlan 
        };
    }

    if (deficit > 5) {
        return { type: 'unachievable', title: t.pstUnachievableTitle, desc: t.pstUnachievableDesc };
    }

    const workoutPlan = [
      { week: "1-2", pushups: { sets: 3, reps: "8-10" }, dips: { sets: 3, reps: "4-6" } },
      { week: "3-4", pushups: { sets: 3, reps: "10-12" }, dips: { sets: 3, reps: "6-8" } },
      { week: "5-6", pushups: { sets: 3, reps: "12-15" }, dips: { sets: 3, reps: "8-10" } },
      { week: "7-8", pushups: { sets: 3, reps: language === 'en' ? "As many as possible" : "जितना संभव हो सके" }, dips: { sets: 3, reps: language === 'en' ? "As many as possible" : "जितना संभव हो सके" } },
    ];

    return { type: 'progressive', title: t.pstWorkoutPlanTitle, intro: t.pstWorkoutPlanIntro, weeklyWorkouts: workoutPlan, gym: { title: t.pstExerciseGym, desc: t.pstGymExercisesDesc }, ...commonElements, dietPlan };
  };

  const handlePSTPlanGeneration = () => {
      if (showPlan) {
          setShowPlan(false);
          setPstPlan(null);
      } else {
          const plan = generatePSTChestPlan();
          setPstPlan(plan);
          setShowPlan(true);
      }
  }

  const getStatusColor = (status) => {
    switch (status) {
      case t.statusYes: return 'text-green-600 bg-green-50 border-green-200';
      case t.statusNo: return 'text-red-600 bg-red-50 border-red-200';
      case t.statusTentative: return 'text-yellow-600 bg-yellow-50 border-yellow-200';
      default: return 'text-gray-600 bg-gray-50 border-gray-200';
    }
  };
  
  const handleGeneratePETPlan = () => {
    const { q1, q2_raw, q3 } = petFormData;
    if (!q1 || !q2_raw || !q3) {
      showCustomAlert(t.alertFillAllPETFields);
      return;
    }
    
    const q1_num = parseInt(q1, 10);
    const q2_raw_num = parseInt(q2_raw, 10);
    const q2 = Math.round(q2_raw_num / 4);
    
    let plan;
    if (q3 === 'Severe injury') {
      plan = t.planPS;
    } else if (q3 === 'Mild injury') {
      plan = t.planPR;
    } else if (q1_num >= 16 && q2 >= 4) {
      plan = t.planPA;
    } else if (q1_num >= 8 && q1_num <= 15 && q2 >= 2 && q2 <= 4) {
      plan = t.planPB;
    } else if (q1_num >= 3 && q1_num <= 7 && q2 >= 1 && q2 <= 3) {
      plan = t.planPC;
    } else {
      plan = t.planPD;
    }

    setPetPlanContent(plan);
    setIsPlanUnlocked(false); 
  };
  
  const downloadCombinedPlansAsPDF = async () => {
      if (isMobile) {
          showCustomAlert(t.pdfDownloadOnDesktop);
          return;
      }
  
      if (!scriptsLoaded) {
          showCustomAlert("PDF generation scripts are still loading. Please try again in a moment.");
          return;
      }
      
      const { name } = downloadFormData;
      if (!name) {
          showCustomAlert("Please unlock the plan first by filling out your details.");
          setShowDownloadModal(true);
          return;
      }
  
      const { jsPDF } = window.jspdf;
      const pdf = new jsPDF({ orientation: 'p', unit: 'mm', format: 'a4' });
      
      // --- PDF Generation Constants ---
      const topMargin = 20, sideMargin = 10, bottomMargin = 20;
      const componentSpacing = 5;
      const pdfPageWidth = pdf.internal.pageSize.getWidth();
      const pdfPageHeight = pdf.internal.pageSize.getHeight();
      const contentWidth = pdfPageWidth - (sideMargin * 2);
  
      // --- Helper to add a plan's sub-header ---
      const addSubHeader = (pdfDoc, title, y) => {
          pdfDoc.setFont('helvetica', 'bold');
          pdfDoc.setFontSize(16);
          pdfDoc.text(title, pdfPageWidth / 2, y, { align: 'center' });
          return y + 10;
      };

      let yPosition = 0;
      let currentPage = 1;

      // Add main header only on the first page
      pdf.setFont('helvetica', 'bold');
      pdf.setFontSize(20);
      pdf.text('SSC GD Training Plan', pdfPageWidth / 2, topMargin, { align: 'center' });
      pdf.setFont('helvetica', 'normal');
      pdf.setFontSize(14);
      pdf.text(`For: ${name}`, pdfPageWidth / 2, topMargin + 10, { align: 'center' });
      yPosition = topMargin + 15;
      
      const addPlanToPDF = async (planId, title) => {
          const planElement = document.getElementById(planId);
          if (!planElement || planElement.offsetHeight === 0) return;
  
          // Add page break before PET plan unconditionally
          if (planId === 'pet-plan-container') {
              pdf.addPage();
              currentPage++;
              yPosition = topMargin;
          }

          yPosition = addSubHeader(pdf, title, yPosition);

          const downloadButton = planElement.querySelector('.download-pdf-button');
          if (downloadButton) downloadButton.style.visibility = 'hidden';
          
          const planWrapper = planElement.querySelector('.plan-content-wrapper');
          if (!planWrapper) {
              if (downloadButton) downloadButton.style.visibility = 'visible';
              return;
          }
  
          // Get all components to render
          const components = [];
          if (planId === 'pst-plan-container') {
              const container = planWrapper.querySelector('.space-y-6');
              if (container) components.push(...Array.from(container.children));
          } else { // For PET plan
              const petContent = planWrapper.querySelector('.bg-white.p-4.rounded-lg');
              if(petContent) components.push(petContent);
          }
  
          for (const component of components) {
              if (!component) continue;
              const canvas = await window.html2canvas(component, { scale: 2, useCORS: true, backgroundColor: '#ffffff' });
              const imgData = canvas.toDataURL('image/png');
              const imgHeight = (canvas.height * contentWidth) / canvas.width;
  
              if (yPosition + imgHeight > pdfPageHeight - bottomMargin) {
                  pdf.addPage();
                  currentPage++;
                  yPosition = topMargin;
              }
  
              pdf.addImage(imgData, 'PNG', sideMargin, yPosition, contentWidth, imgHeight);
              yPosition += imgHeight + componentSpacing;
          }
  
          if (downloadButton) downloadButton.style.visibility = 'visible';
      };
  
      await addPlanToPDF('pst-plan-container', 'Physical Standard Test (PST) Plan');
      await addPlanToPDF('pet-plan-container', 'Physical Efficiency Test (PET) Plan');
  
      pdf.save('SSC-GD-Training-Plans.pdf');
  };

  const handleDownloadSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const { name, email, phone } = downloadFormData;
    const { rollNumber } = formData;

    const baseUrl = "https://script.google.com/macros/s/AKfycbyQSIycc83NrtT_2pvddS6Tld_6ngzJzIrmO409nUNWzgDYSyv6-OGw64bkY9RnoJkXHg/exec";
    const params = new URLSearchParams();
    params.append("Name", name);
    params.append("Number", phone);
    params.append("Email", email);
    params.append("RollNumber", rollNumber || 'N/A');

    const fullUrl = `${baseUrl}?${params.toString()}`;

    try {
        await fetch(fullUrl, { redirect: 'follow' });
        console.log("API call initiated successfully.");

        setIsPlanUnlocked(true);
        setShowDownloadModal(false);
        if (!isMobile) {
            setTimeout(() => {
              downloadCombinedPlansAsPDF();
            }, 100);
        }
    } catch (error) {
        console.error("Error submitting to Google Script:", error);
        showCustomAlert("There was an error submitting your details. Please try again.");
    } finally {
        setIsSubmitting(false);
    }
  };
  
  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6 bg-white rounded-lg shadow-lg">
      {showDownloadModal && <DownloadModal t={t} onSubmit={handleDownloadSubmit} onClose={() => setShowDownloadModal(false)} formData={downloadFormData} onChange={handleDownloadFormChange} isSubmitting={isSubmitting} isMobile={isMobile} />}
      <div className="flex justify-end mb-4">
        <button
          onClick={() => setLanguage(language === 'en' ? 'hi' : 'en')}
          className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition duration-200"
        >
          {language === 'en' ? 'हिन्दी में बदलें' : 'Switch to English'}
        </button>
      </div>
      <h1 className="text-2xl sm:text-3xl font-bold text-center mb-4 text-gray-800">
        {t.appTitle}
      </h1>
      
      <p className="text-center text-gray-700 mb-8 text-base sm:text-lg" dangerouslySetInnerHTML={{ __html: t.welcomeMessage.replace(/(.*?)<\/selection-tag>/, '$1') }} />

      
      <div className="mb-8">
        <h2 className="text-xl sm:text-2xl font-bold mb-4 text-gray-800 text-center">
          {t.pstSectionTitle}
        </h2>
        
        <p className="text-gray-700 mb-6 text-left">
          {t.pstIntro}
        </p>
        
        <div className="mb-6 overflow-x-auto">
          <table className="w-full max-w-3xl mx-auto border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-50">
                <th className="border border-gray-300 p-3 text-left font-semibold">{t.tableHeaderParameter}</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">{t.tableHeaderMale}</th>
                <th className="border border-gray-300 p-3 text-left font-semibold">{t.tableHeaderFemale}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3 font-semibold">{t.height}</td>
                <td className="border border-gray-300 p-3">{t.heightMaleValue}</td>
                <td className="border border-gray-300 p-3">{t.heightFemaleValue}</td>
              </tr>
              <tr className="bg-gray-50">
                <td className="border border-gray-300 p-3 font-semibold">{t.chest}</td>
                <td className="border border-gray-300 p-3">{t.chestMaleValue}</td>
                <td className="border border-gray-300 p-3">{t.chestFemaleValue}</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3 font-semibold">{t.weight}</td>
                <td className="border border-gray-300 p-3" colSpan={2}>{t.weightValue}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-sm italic text-gray-700 mb-6 text-center">
          {t.noteRelaxation}
        </p>
        
        <div className="text-center mb-6">
            <button
                onClick={() => setShowForm(!showForm)}
                className="inline-flex items-center justify-center bg-indigo-600 text-white font-semibold py-2 px-4 sm:py-3 sm:px-6 rounded-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300"
            >
                <span>{t.assessPSTFitness}</span>
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-5 w-5 ml-2 transition-transform duration-300 ${showForm ? 'rotate-180' : ''}`} viewBox="0 0 20 20" fill="currentColor">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
            </button>
        </div>
          
        <div className={`transition-all duration-700 ease-in-out overflow-hidden ${showForm ? 'max-h-[10000px] opacity-100' : 'max-h-0 opacity-0'}`}>
            <div className="bg-gray-50 p-4 sm:p-6 rounded-lg border border-gray-200 mt-4">
              <p className="text-gray-700 mb-6 text-center">
                {t.pstFormIntro}
              </p>
              
              <div className="grid md:grid-cols-2 gap-6 mb-6">
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t.sex} *
                    </label>
                    <select
                      name="sex"
                      value={formData.sex}
                      onChange={handleInputChange}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value="" disabled className="text-gray-400">{t.placeholderSex}</option>
                      <option value="Male">{t.male}</option>
                      <option value="Female">{t.female}</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t.category} *
                    </label>
                    <select
                      name="category"
                      value={formData.category}
                      onChange={handleInputChange}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    >
                      <option value="">{t.selectCategory}</option>
                      {categories.map(cat => (
                        <option key={cat.value} value={cat.value}>{cat.label}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t.heightCm} *
                    </label>
                    <input
                      type="number"
                      name="height"
                      min="100"
                      max="250"
                      value={formData.height}
                      onChange={handleInputChange}
                      placeholder={t.placeholderHeight}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                  </div>
                   <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t.weightKg} *
                    </label>
                    <input
                      type="number"
                      name="weight"
                      step="0.1"
                      min="30"
                      max="150"
                      value={formData.weight}
                      onChange={handleInputChange}
                      placeholder={t.placeholderWeight}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    />
                  </div>
                </div>

                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t.chestUnexpanded} {formData.sex === 'Male' ? '*' : ''}
                    </label>
                    <input
                      type="number"
                      name="chestNormal"
                      step="1"
                      min="60"
                      max="150"
                      value={formData.chestNormal}
                      onChange={handleInputChange}
                      placeholder={t.placeholderChestNormal}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      disabled={formData.sex === 'Female'}
                    />
                    {formData.sex === 'Female' && (
                      <p className="text-sm text-gray-500 mt-1">{t.femaleNotRequired}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t.chestExpanded} {formData.sex === 'Male' ? '*' : ''}
                      {formData.sex === 'Male' && (
                        <button
                          type="button"
                          onClick={() => setShowChestInfo(!showChestInfo)}
                          className="ml-2 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-indigo-500 rounded-full hover:bg-indigo-600 focus:outline-none"
                          title={t.chestMeasurementInfo}
                        >
                          ?
                        </button>
                      )}
                    </label>
                    {showChestInfo && formData.sex === 'Male' && (
                      <div className="mb-3 p-3 bg-indigo-50 border border-indigo-200 rounded-md text-sm text-indigo-800">
                        <p className="font-semibold mb-2">{t.chestMeasurementInfo}</p>
                        <ol className="list-decimal ml-4 space-y-1">
                          <li>{t.chestMeasureStep1}</li>
                          <li>{t.chestMeasureStep2}</li>
                          <li>{t.chestMeasureStep3}</li>
                          <li>{t.chestMeasureStep4}</li>
                          <li>{t.chestMeasureStep5}</li>
                          <li>{t.chestMeasureStep6}</li>
                        </ol>
                      </div>
                    )}
                    <input
                      type="number"
                      name="chestDeepInhale"
                      step="1"
                      min="60"
                      max="155"
                      value={formData.chestDeepInhale}
                      onChange={handleInputChange}
                      placeholder={t.placeholderChestDeepInhale}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      disabled={formData.sex === 'Female'}
                    />
                    {formData.sex === 'Female' && (
                      <p className="text-sm text-gray-500 mt-1">{t.femaleNotRequired}</p>
                    )}
                    {formData.sex === 'Male' && formData.chestNormal && formData.chestDeepInhale && 
                     parseInt(formData.chestDeepInhale) <= parseInt(formData.chestNormal) && (
                      <p className="text-sm text-red-600 mt-1">
                        {t.chestSizeError}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      {t.rollNumber} *
                    </label>
                    <input
                      type="text"
                      name="rollNumber"
                      value={formData.rollNumber}
                      onChange={handleInputChange}
                      placeholder={t.placeholderRollNumber}
                      className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                      maxLength="10"
                    />
                    {formData.rollNumber && formData.rollNumber.length !== 10 && (
                      <p className="text-sm text-red-600 mt-1">{t.rollNumberError}</p>
                    )}
                  </div>
                </div>
              </div>

              <button
                onClick={checkCriteria}
                className="w-full bg-indigo-600 text-white py-3 px-4 rounded-md hover:bg-indigo-700 transition duration-200 font-medium text-base sm:text-lg disabled:bg-gray-400 disabled:cursor-not-allowed"
                disabled={formData.sex === 'Male' && formData.chestNormal && formData.chestDeepInhale && 
                         parseInt(formData.chestDeepInhale) <= parseInt(formData.chestNormal) || 
                         !formData.rollNumber || formData.rollNumber.length !== 10}
              >
                {t.checkPSTEligibility}
              </button>

              {result && (
                <div className="mt-6">
                  <h2 className="text-lg sm:text-xl font-semibold mb-4">{t.pstResultTitle}</h2>
                  
                  <div className={`p-4 rounded-lg border-2 mb-4 ${getStatusColor(result.status)}`}>
                    <div className="text-xl sm:text-2xl font-bold mb-2">{result.status}</div>
                    <div className="text-sm">{result.message}</div>
                  </div>

                  <div className="bg-gray-100 p-4 rounded-lg mb-4">
                    <h3 className="font-semibold mb-3">{t.detailedAssessment}</h3>
                    <div className="space-y-2">
                      {result.details.map((detail, index) => (
                        <div key={index} className="text-sm font-mono bg-white p-2 rounded border break-words">
                          {detail}
                        </div>
                      ))}
                    </div>
                  </div>

                  {result && !result.heightFail && formData.sex === 'Male' && (
                    <div className="mt-8">
                        <div className="text-center">
                            <button
                                onClick={handlePSTPlanGeneration}
                                className="w-full bg-green-600 text-white font-semibold py-3 px-6 rounded-lg hover:bg-green-700 transition-all duration-300 shadow-md text-base sm:text-lg"
                            >
                                <span>{showPlan ? t.pstPlanCtaButtonHide : t.makePersonalizedPlanPST}</span>
                            </button>
                        </div>
                
                        <div className={`transition-all duration-700 ease-in-out overflow-hidden ${showPlan ? 'max-h-[10000px] opacity-100' : 'max-h-0 opacity-0'}`}>
                            {pstPlan && (
                                <div className="mt-4 border border-gray-200 rounded-lg p-4 bg-white" id="pst-plan-container">
                                    <div className="plan-content-wrapper">
                                        {pstPlan.type === 'unachievable' && (
                                            <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4">
                                                <h4 className="font-bold text-lg sm:text-xl text-gray-900 mb-4 border-b-2 border-gray-200 pb-2">{pstPlan.title}</h4>
                                                <p>{pstPlan.desc}</p>
                                            </div>
                                        )}
                                        {(pstPlan.type === 'maintenance' || pstPlan.type === 'progressive') && (
                                          <div className="space-y-6">
                                            <div className="bg-white p-4 rounded-lg border">
                                              <h3 className="font-bold text-md sm:text-lg text-gray-800 mb-2">{pstPlan.title}</h3>
                                              <p className="text-sm text-gray-600 mb-4">{pstPlan.intro}</p>
                                              {pstPlan.type === 'maintenance' && (
                                                <div className="space-y-2">
                                                  <p className="text-sm text-gray-800 font-semibold">{pstPlan.workoutDesc}</p>
                                                  <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 ml-4">
                                                    {pstPlan.workouts.map((wo, i) => <li key={i}><strong>{wo.exercise}:</strong> {wo.reps}</li>)}
                                                  </ul>
                                                </div>
                                              )}
                                              {pstPlan.type === 'progressive' && (
                                                <div className="space-y-4">
                                                  {pstPlan.weeklyWorkouts.map((weekPlan, index) => (
                                                    <div key={index}>
                                                      <h4 className="font-semibold text-md text-gray-700 border-b pb-1 mb-2">{t.pstWeekHeader.replace('{week}', weekPlan.week)}</h4>
                                                      <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 ml-4">
                                                        <li><strong>{t.pstExercisePushups}:</strong> {weekPlan.pushups.sets} sets of {weekPlan.pushups.reps} reps.</li>
                                                        <li><strong>{t.pstExerciseDips}:</strong> {weekPlan.dips.sets} sets of {weekPlan.dips.reps} reps.</li>
                                                      </ul>
                                                    </div>
                                                  ))}
                                                  <div className="bg-gray-100 p-3 rounded-lg mt-4">
                                                    <p className="text-sm text-gray-800"> • <strong>{pstPlan.gym.title}:</strong> {pstPlan.gym.desc}</p>
                                                  </div>
                                                  <div className="bg-indigo-50 p-3 rounded-lg border border-indigo-200 mt-4">
                                                    <h4 className="font-semibold text-indigo-800">{pstPlan.assistance.title}</h4>
                                                    <p className="text-sm text-indigo-700 mt-1">{pstPlan.assistance.desc}</p>
                                                  </div>
                                                </div>
                                              )}
                                            </div>
                                            <div className="bg-white p-4 rounded-lg border mt-6">
                                              <h4 className="font-bold text-md sm:text-lg text-gray-800 mb-2">{pstPlan.expansion.title}</h4>
                                              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 ml-4">
                                                {pstPlan.expansion.items.map((item, index) => <li key={index}>{item}</li>)}
                                              </ul>
                                              <h5 className="font-semibold text-gray-700 mt-3">{pstPlan.cardio.title}</h5>
                                              <p className="text-sm text-gray-600 ml-4">• {pstPlan.cardio.desc}</p>
                                            </div>
                                            <div className="bg-white p-4 rounded-lg border mt-6">
                                              <h3 className="font-bold text-md sm:text-lg text-gray-800 mb-2">{pstPlan.dietPlan.title}</h3>
                                              <p className="text-sm text-gray-600 mb-4">{pstPlan.dietPlan.intro}</p>
                                              <div className="space-y-3">
                                                <div>
                                                  <h4 className="font-semibold text-gray-700">{pstPlan.dietPlan.protein.title}</h4>
                                                  <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 ml-4">
                                                    <li>{pstPlan.dietPlan.protein.veg}</li>
                                                    <li>{pstPlan.dietPlan.protein.nonVeg}</li>
                                                  </ul>
                                                </div>
                                                <div>
                                                  <h4 className="font-semibold text-gray-700">{pstPlan.dietPlan.tips.title}</h4>
                                                  <ul className="list-disc list-inside text-sm text-gray-600 space-y-1 ml-4">
                                                    {pstPlan.dietPlan.tips.items.map((item, index) => <li key={index}>{item}</li>)}
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                            <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mt-6">
                                              <h4 className="font-bold">{pstPlan.safety.title}</h4>
                                              <p>{pstPlan.safety.desc}</p>
                                            </div>
                                          </div>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                  )}
                  <div className="text-xs text-gray-500 mt-4">
                    <p><strong>{t.note}:</strong> {t.noteThisTool}</p>
                  </div>
                </div>
              )}
            </div>
        </div>
      </div>

      <div className="mt-6">
        <h2 className="text-xl sm:text-2xl font-bold text-center mb-6 text-gray-800">
          {t.petSectionTitle}
        </h2>
        
        <div className="bg-blue-50 p-4 sm:p-6 rounded-lg border border-blue-200 mb-6">
          <h3 className="font-semibold text-blue-800 mb-4">{t.raceRequirements}</h3>
          
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-blue-300">
              <thead>
                <tr className="bg-blue-100">
                  <th className="border border-blue-300 p-3 text-left font-semibold">{t.tableHeaderEvent}</th>
                  <th className="border border-blue-300 p-3 text-left font-semibold">{t.tableHeaderMale}</th>
                  <th className="border border-blue-300 p-3 text-left font-semibold">{t.tableHeaderFemale}</th>
                  <th className="border border-gray-300 p-3 text-left font-semibold">{t.tableHeaderRemarks}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-blue-300 p-3 font-medium" rowSpan={2}>{t.race}</td>
                  <td className="border border-blue-300 p-3">{t.raceMale1}</td>
                  <td className="border border-blue-300 p-3">{t.raceFemale1}</td>
                  <td className="border border-blue-300 p-3">{t.raceRemarks1}</td>
                </tr>
                <tr>
                  <td className="border border-blue-300 p-3">{t.raceMale2}</td>
                  <td className="border border-blue-300 p-3">{t.raceFemale2}</td>
                  <td className="border border-blue-300 p-3">{t.raceRemarks2}</td>
                </tr>
              </tbody>
            </table>
          </div>
          
          <div className="mt-4 text-sm text-blue-700">
            <p className="font-medium">{t.notePregnantFemale}</p>
          </div>
        </div>

        <div className="mb-6">
            <button
                onClick={() => { setShowPETForm(!showPETForm); setPetPlanContent(null); }}
                className={`w-full text-base sm:text-lg font-bold text-white transition-all duration-300 flex justify-center items-center bg-purple-600 hover:bg-purple-700 py-3 px-6 ${showPETForm ? 'rounded-t-lg' : 'rounded-lg'}`}
            >
                <span className="mx-2">{t.createPersonalizedTrainingPlan}</span>
                <svg xmlns="http://www.w3.org/2000/svg" className={`h-6 w-6 transition-transform duration-300 ${showPETForm ? '' : 'rotate-180'}`} viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
            </button>
            <div className={`transition-all duration-700 ease-in-out overflow-hidden ${showPETForm ? 'max-h-[1000px]' : 'max-h-0'}`}>
                <div className="p-4 sm:p-6 bg-violet-50 border border-t-0 border-purple-300 rounded-b-lg">
                  <h3 className="font-semibold text-purple-800 mb-4">{t.trainingAssessmentForm}</h3>
                  
                  <div className="space-y-6">
                    <PetQuestion id="q1" text={t.petQ1}>
                      <input
                        id="q1"
                        name="q1"
                        type="number"
                        min="0"
                        max="120"
                        value={petFormData.q1}
                        onChange={handlePetInputChange}
                        placeholder={t.placeholderMinutes}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      />
                    </PetQuestion>

                    <PetQuestion id="q2_raw" text={t.petQ2}>
                       <input
                        id="q2_raw"
                        name="q2_raw"
                        type="number"
                        min="0"
                        max="30"
                        value={petFormData.q2_raw}
                        onChange={handlePetInputChange}
                        placeholder={t.placeholderDays}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      />
                    </PetQuestion>

                    <PetQuestion id="q3" text={t.petQ3}>
                      <select
                        id="q3"
                        name="q3"
                        value={petFormData.q3}
                        onChange={handlePetInputChange}
                        className="w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      >
                        <option value="">{t.selectInjuryStatus}</option>
                        <option value="No injury">{t.petQ3_Opt1}</option>
                        <option value="Mild injury">{t.petQ3_Opt2}</option>
                        <option value="Severe injury">{t.petQ3_Opt3}</option>
                      </select>
                    </PetQuestion>

                    <button
                        onClick={handleGeneratePETPlan}
                        className="w-full bg-purple-600 text-white py-3 px-4 rounded-md hover:bg-purple-700 transition duration-200 font-medium text-base sm:text-lg"
                    >
                        {t.generatePETTrainingPlan}
                    </button>
                  </div>
                </div>
            </div>
        </div>

        {petPlanContent && (
          <div id="pet-plan-container" className="mt-6 bg-green-50 p-4 sm:p-6 rounded-lg border border-green-200" >
              <div className="relative plan-content-wrapper">
                  <h3 className="text-xl sm:text-2xl font-bold text-green-800 mb-4 border-b-2 border-green-200 pb-2">{t.petTrainingPlanTitle}</h3>
                  <div className="bg-white p-4 rounded-lg">
                      <PetPlanRenderer 
                        content={petPlanContent} 
                        isLocked={!isPlanUnlocked} 
                        t={t} 
                        onUnlock={() => setShowDownloadModal(true)}
                        onDownload={downloadCombinedPlansAsPDF}
                        isMobile={isMobile}
                      />
                  </div>
              </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PSTChecker;


